const routes = [
  {
    path: '/dayi/1',
    name: 'dayi1',
    meta: {
      title: '“蓉城人才绿卡”大邑卡服务实施细则'
    },
    component: () => import('./1.vue')
  },
]

export default routes